<template>
    <div>
        <v-date-picker
            v-model="range"
            mode="date"
            is-range
            show-caps
            :columns="2"
            :is-vertical="isMobile"
            @input="applyFilter"
            class="datepicker"
            :showDayPopover="false"
            nav-visibility="click"
            :popover="{ visibility: 'click' }"
        >
            <template v-slot="{ inputValue, inputEvents }">
                <div class="date-form-group">
                    <div class="clear-btn">
                        <b-button variant="danger" @click="clearRange">
                            <i class="fa fa-trash-o"></i>
                        </b-button>
                    </div>
                    <img
                        :src="require('@/assets/icons/calendar.svg')"
                        class="icon"
                        id="iconnn"
                    />
                    <date-input
                        :placeholder="$t('vueFormWizard.startDate')"
                        :value="range.start"
                        :inputValue="inputValue.start"
                        :inputEvents="inputEvents.start"
                    />
                    <date-input
                        :placeholder="$t('vueFormWizard.endDate')"
                        :value="range.end"
                        :inputValue="inputValue.end"
                        :inputEvents="inputEvents.end"
                    />
                </div>
            </template>
        </v-date-picker>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { setupCalendar, DatePicker as VDatePicker } from 'v-calendar'

import DateInput from './DateInput.vue'

import { isMobile } from './helpers'

setupCalendar({
    locale: i18n.locale,
    navVisibility: 'focus',
    popoverDirection: 'bottom',
    popoverVisibility: 'focus',
    popoverAlign: 'right',
})

export default {
    name: 'DatePicker',
    components: {
        VDatePicker,
        DateInput,
    },
    data() {
        return {
            range: {
                start: null,
                end: null,
            },
        }
    },
    computed: {
        isMobile() {
            return isMobile()
        },
    },
    methods: {
        applyFilter() {
            const date = {
                start: this.range.start,
                end: this.range.end,
            }

            this.$emit('changed', date)
        },
        clearRange() {
            this.range = {
                start: null,
                end: null,
            }
            this.applyFilter()
        },
    },
}
</script>
<style lang="sass" scoped>
.filters-row
    width: 100%
    display: flex
    justify-content: flex-end
.date-form-group
    display: flex
    justify-content: flex-start
    position: relative
    .icon
        margin-bottom: 0px
    .clear-btn
        display: none
        opacity: 0
        transition: 1s ease all
        position: absolute
        right: 0
        top: 50%
        transform: translateY(-50%) translateX(100%)
        &:hover
            display: inline-block
            opacity: 1
    &:hover,
    &:focus
        .clear-btn
            display: inline-block
            opacity: 1


::v-deep
    .popover-origin .popover-content-wrapper .popover-content.align-right::after
        display: none
</style>
